const comments = [
  {
    name: '综艺达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20young%20Chinese%20person%20with%20warm%20lighting%20soft%20neutral%20expression%20clean%20background%20professional%20headshot%20style%20modern%20and%20friendly&width=80&height=80&seq=avatar-01-6080&orientation=squarish',
    time: '3天前',
    content: '追了这么多网站，6080是真的良心。画质清晰不卡顿，更新还特别快。奔跑吧最新一期晚上电视刚播完，半小时后这里就能看了，太强了！',
  },
  {
    name: '音乐发烧友小李',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20lighting%20friendly%20smile%20clean%20background%20professional%20headshot%20style%20modern%20photography&width=80&height=80&seq=avatar-02-6080&orientation=squarish',
    time: '5天前',
    content: '歌手2025的音质真的绝了，用耳机听效果特别好。比某些收费平台画质还好，关键是完全免费，已经推荐给身边所有追综艺的朋友了。',
  },
  {
    name: '密室爱好者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20young%20Asian%20man%20with%20warm%20lighting%20casual%20expression%20clean%20background%20professional%20headshot%20style%20modern%20and%20clean&width=80&height=80&seq=avatar-03-6080&orientation=squarish',
    time: '1周前',
    content: '密室大逃脱第六季太精彩了！6080的播放体验很稳定，从头看到尾没有一次缓冲，弹幕功能也有意思，看综艺一定要开弹幕才完整。',
  },
  {
    name: '脱口秀铁粉小周',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20young%20Chinese%20person%20with%20warm%20lighting%20gentle%20smile%20clean%20background%20professional%20headshot%20style%20modern%20photography&width=80&height=80&seq=avatar-04-6080&orientation=squarish',
    time: '1周前',
    content: '下班后最大的快乐就是打开6080看脱口秀大会，笑到肚子疼。资源全画质好，还有往季的经典回顾，新入坑的也能从第一季开始补，太贴心了。',
  },
  {
    name: '乘风破浪团粉小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20lighting%20bright%20expression%20clean%20background%20professional%20headshot%20style%20modern%20friendly&width=80&height=80&seq=avatar-05-6080&orientation=squarish',
    time: '2周前',
    content: '乘风破浪成团夜看哭了，姐姐们太不容易了。6080的画质真的能打，舞台效果每个细节都看得清清楚楚。强烈建议出个"姐姐名场面"合集！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            观众热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            看看追综同好们怎么说6080影视
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.slice(0, 3).map((comment, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 border border-background-300/20">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200/60">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-200">{comment.name}</div>
                  <div className="text-xs text-foreground-600">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-300/15">
                <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-thumb-up-line mr-1"></i>有用
                </span>
                <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
              </div>
            </div>
          ))}
          {comments.slice(3).map((comment, idx) => (
            <div key={idx + 3} className="bg-background-100 rounded-xl p-5 border border-background-300/20 hidden lg:block">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200/60">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-200">{comment.name}</div>
                  <div className="text-xs text-foreground-600">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-300/15">
                <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-thumb-up-line mr-1"></i>有用
                </span>
                <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}